var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _path3, _rect53, _rect54, _rect55, _rect56, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeatmapPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16345 0 16 0H31.6667V19H0V16Z",
    fill: "#868E96"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.333 0H184C192.836 0 200 7.16344 200 16V19H168.333V0Z",
    fill: "#ADB5BD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 20.2,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 20.2,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 20.2,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 20.2,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 20.2,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 20.2,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 40.4,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 40.4,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 40.4,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 40.4,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 40.4,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 40.4,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 60.6,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 60.6,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 60.6,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 60.6,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 60.6,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 60.6,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    y: 80.8,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 80.8,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 80.8,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 80.8,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 80.8,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 80.8,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    y: 101,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 101,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 101,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 101,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 101,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 101,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    y: 121.2,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 121.2,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 121.2,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 121.2,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 121.2,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 121.2,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    y: 141.4,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 141.4,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 141.4,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 141.4,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 141.4,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 141.4,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    y: 161.6,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 161.6,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 161.6,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 161.6,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 161.6,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 168.333,
    y: 161.6,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 181.8H31.6667V200.8H16C7.16343 200.8 0 193.637 0 184.8V181.8Z",
    fill: "#868E96"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 181.8,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3333,
    y: 181.8,
    width: 31.6667,
    height: 19,
    fill: "#ADB5BD"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 181.8,
    width: 31.6667,
    height: 19,
    fill: "#868E96"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 134.667,
    y: 181.8,
    width: 31.6667,
    height: 19,
    fill: "#373D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.333 181.8H200V184.8C200 193.637 192.836 200.8 184 200.8H168.333V181.8Z",
    fill: "#868E96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapPreview);
export default __webpack_public_path__ + "static/media/heatmapPreview.0152351a1d2009a3c878ddbf7eedeb50.svg";
export { ForwardRef as ReactComponent };